// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ActionablesAtGlance from "./pages/ActionablesAtGlance";
import ActionableDetail from "./pages/ActionableDetail";
import Header from "./components/Header";
import SelectPolicy from "./pages/SelectPolicy"; // NEW import
import SystemTrigger from "./pages/SystemTrigger"; 
import ExternalTrigger from "./pages/ExternalTrigger";
import ActionablesDashboard from './pages/ActionablesDashboard';
import ActionablesByStatus from './pages/ActionablesByStatus';
import ActionablesCalendar from "./pages/ActionablesCalendar";
import ExceptionReporting from "./pages/ExceptionReporting";
import ContactUs from "./pages/ContactUs";
import Reports from "./pages/Reports";
import ActionableMasterDetail from "./pages/ActionableMasterDetail";
import IsoMeetingsHome from "./pages/IsoMeetingsHome";
import MeetingInvite from "./pages/MeetingInvite";
import MeetingList from "./pages/MeetingList";
import PoliciesList from "./pages/PoliciesList";
import ChangePassword from "./pages/ChangePassword";
// top of file
import PolicyReviewsMenu from "./pages/PolicyReviewsMenu";
import CreateReview from "./pages/CreateReview";
import ReviewsList from "./pages/ReviewsList";
import ReviewDetail from "./pages/ReviewDetail";
import ExceptionReportsView from "./pages/ExceptionReportsView";

// inside your <Routes> ... </Routes>



function App() {
  return (
    <Router>
      {/* Login route remains standalone */}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />

        {/* SelectPolicy page (user picks policy before opening ActionablesAtGlance) */}
        <Route
          path="/select-policy"
          element={<><Header /><SelectPolicy /></>}
        />

        {/* All authenticated pages with Header */}
        <Route
          path="/*"
          element={
            <>
              <Header />
              <Routes>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="actionables-glance" element={<ActionablesAtGlance />} />
                <Route path="actionable/:uat_id" element={<ActionableDetail />} />
                <Route path="system-trigger" element={<SystemTrigger />} /> 
                <Route path="external-trigger" element={<ExternalTrigger />} />
                <Route path="/actionables" element={<ActionablesDashboard />} />

                {/* Status pages — support both route styles so calendar & links both work */}
                <Route path="/actionables/status/:status" element={<ActionablesByStatus />} />
                <Route path="/actionables/status/:status/:date" element={<ActionablesByStatus />} />
                <Route path="/actionables-by-status/:status" element={<ActionablesByStatus />} />
                <Route path="/actionables-by-status/:status/:date" element={<ActionablesByStatus />} />

                <Route path="/actionables-calendar" element={<ActionablesCalendar />} />
                <Route path="/exception-reporting" element={<ExceptionReporting />} />
                <Route path="/exception-reports" element={<ExceptionReportsView />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/actionable-master/:id" element={<ActionableMasterDetail />} />
                <Route path="/policy-review" element={<IsoMeetingsHome />} />
                <Route path="/meetings/invite" element={<MeetingInvite />} />
                <Route path="/meetings/list" element={<MeetingList />} />
                <Route path="/policies" element={<PoliciesList />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/policy-reviews" element={<PolicyReviewsMenu />} />
                <Route path="/policy-reviews/new" element={<CreateReview />} />
                <Route path="/policy-reviews/list" element={<ReviewsList />} />
                <Route path="/policy-reviews/:id" element={<ReviewDetail />} />
                <Route path="/policy-reviews/:id/edit" element={<CreateReview />} />

              </Routes>
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
